// Shared match logic for the dispatch omni-search feature. Both the in-product
// highlighting (HighlightedText) and the "why matched" badge derivation
// (deriveOrderSearchMatchFields) run through the same predicate so a chip and a
// highlight can never disagree about whether a value matched the search term.

export function escapeRegex(searchTerm: string) {
  return searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

// A value matches when it contains the trimmed search term, case-insensitively.
// An empty or whitespace-only term matches nothing.
export function matchesSearchTerm(value: string, searchTerm: string) {
  const trimmedSearchTerm = searchTerm.trim();

  if (!trimmedSearchTerm) {
    return false;
  }

  return value.toLocaleLowerCase().includes(trimmedSearchTerm.toLocaleLowerCase());
}
